import produce from "immer";
import { IEntity, IStatusKey } from "../../types";
import { clamp } from "./statsHelper";

type IApplyStatusExecutor = {
  [K in IStatusKey]: {
    activate: (draft: IEntity, turn: number) => void;
    deactivate: (draft: IEntity) => void;
  };
};

// warning: these functions will be used by a pure function(applyStatus)
// do NOT use them elsewhere

const poison = {
  activate: (draft: IEntity) => {
    const { hp } = draft.stats;
    hp.value -= 1;
    clamp(hp);
  },
  deactivate: () => {}
};

const blind = {
  activate: (draft: IEntity, relativeTurn: number) => {
    const { attack } = draft.stats;
    if (relativeTurn === 2 || relativeTurn === 4) attack.value = 0;
    else attack.value = attack.max;
  },
  deactivate: (draft: IEntity) => {
    draft.stats.attack.value = draft.stats.attack.max;
  }
};
const sleep = {
  activate: (draft: IEntity) => {
    draft.stats.attack.value = 0;
    draft.stats.mpAttack.value = 0;
  },
  deactivate: (draft: IEntity) => {
    draft.stats.attack.value = draft.stats.attack.max;
    draft.stats.mpAttack.value = draft.stats.mpAttack.max;
  }
};
const shell = {
  // prettier-ignore
  activate: (draft: IEntity) => { draft.stats.mpDefense.value *= 2 },
  // prettier-ignore
  deactivate: (draft: IEntity) => { draft.stats.mpDefense.value = draft.stats.mpDefense.max }
};

const protect = {
  // prettier-ignore
  activate: (draft: IEntity) => { draft.stats.defense.value *= 2 },
  // prettier-ignore
  deactivate: (draft: IEntity) => { draft.stats.defense.value = draft.stats.defense.max }
};

export const statuses: IApplyStatusExecutor = {
  poison,
  blind,
  sleep,
  shell,
  protect
};

export const applyStatus = (
  actors: IEntity[],
  activeIndex: number
): IEntity[] => {
  return produce(actors, draft => {
    const actor = draft[activeIndex];

    // increase counter for all statuses
    actor.statuses.forEach(status => {
      status.start += 1;
    });

    // remove statuses that have ended
    actor.statuses
      .filter(status => status.start >= status.end)
      .forEach(status => {
        statuses[status.key].deactivate(actor);
      });
    actor.statuses = actor.statuses.filter(status => status.start < status.end);

    // loop through active statuses (start >= 0)
    actor.statuses
      .filter(status => status.start >= 0)
      .forEach(status => {
        statuses[status.key].activate(actor, status.start);
      });
  });
};
